'use strict';

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");
var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits.js");
var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var _require = require('events'),
  EventEmitter = _require.EventEmitter;
var debug = require('debug')('nock.socket');
module.exports = /*#__PURE__*/function (_EventEmitter) {
  _inherits(Socket, _EventEmitter);
  var _super = _createSuper(Socket);
  function Socket(options) {
    var _this;
    _classCallCheck(this, Socket);
    _this = _super.call(this);

    // Pretend this is a TLSSocket
    if (options.proto === 'https') {
      // https://github.com/nock/nock/issues/158
      _this.authorized = true;
      // https://github.com/nock/nock/issues/2147
      _this.encrypted = true;
    }
    _this.bufferSize = 0;
    _this.writableLength = 0;
    _this.writable = true;
    _this.readable = true;
    _this.pending = false;
    _this.destroyed = false;
    _this.connecting = true;

    // Undocumented flag used by ClientRequest to ensure errors aren't double-fired
    _this._hadError = false;

    // Maximum allowed delay. 0 means unlimited.
    _this.timeout = 0;
    var ipv6 = options.family === 6;
    _this.remoteFamily = ipv6 ? 'IPv6' : 'IPv4';
    _this.localAddress = _this.remoteAddress = ipv6 ? '::1' : '127.0.0.1';
    _this.localPort = _this.remotePort = parseInt(options.port);
    return _this;
  }
  _createClass(Socket, [{
    key: "setNoDelay",
    value: function setNoDelay() {}
  }, {
    key: "setKeepAlive",
    value: function setKeepAlive() {}
  }, {
    key: "resume",
    value: function resume() {}
  }, {
    key: "ref",
    value: function ref() {}
  }, {
    key: "unref",
    value: function unref() {}
  }, {
    key: "address",
    value: function address() {
      return {
        port: this.remotePort,
        family: this.remoteFamily,
        address: this.remoteAddress
      };
    }
  }, {
    key: "setTimeout",
    value: function setTimeout(timeoutMs, fn) {
      this.timeout = timeoutMs;
      if (fn) {
        this.once('timeout', fn);
      }
      return this;
    }

    /**
     * Artificial delay that will trip socket timeouts when appropriate.
     *
     * Doesn't actually wait for time to pass.
     * Timeout events don't necessarily end the request.
     * While many clients choose to abort the request upon a timeout, Node itself does not.
     */
  }, {
    key: "applyDelay",
    value: function applyDelay(delayMs) {
      if (this.timeout && delayMs > this.timeout) {
        debug('socket timeout');
        this.emit('timeout');
      }
    }
  }, {
    key: "getPeerCertificate",
    value: function getPeerCertificate() {
      return Buffer.from((Math.random() * 10000 + Date.now()).toString()).toString('base64');
    }

    /**
     * Denotes that no more I/O activity should happen on this socket.
     *
     * The implementation in Node if far more complex as it juggles underlying async streams.
     * For the purposes of Nock, we just need it to set some flags and on the first call
     * emit a 'close' and optional 'error' event. Both events propagate through the request object.
     */
  }, {
    key: "destroy",
    value: function destroy(err) {
      var _this2 = this;
      if (this.destroyed) {
        return this;
      }
      debug('socket destroy');
      this.destroyed = true;
      this.readable = this.writable = false;
      this.readableEnded = this.writableFinished = true;
      process.nextTick(function () {
        if (err) {
          _this2._hadError = true;
          _this2.emit('error', err);
        }
        _this2.emit('close');
      });
      return this;
    }
  }]);
  return Socket;
}(EventEmitter);